'use strict'

import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import _ from 'lodash'

import './assets/vendor/jquery/jquery.min'
import './assets/vendor/jquery_idle/jquery.idle'
import './assets/vendor/jquery_mask_plugin/dist/jquery.mask.min'

import VueGtag from 'vue-gtag-next'

import { EXIT_SITE } from '@/store/action-types'

// DevExtreme license - https://js.devexpress.com/Vue/Documentation/Guide/Common/Licensing/#How_to_Obtain_and_Validate_Your_License_Key
import config from 'devextreme/core/config'
import { licenseKey } from './devextreme-license'
config({ licenseKey })

// GLOBAL UTILS
import utils from './assets/scripts/utilities.js'

// IMPORTANT: must be before semantic/fomantic
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'

import '@/assets/vendor/fomantic-ui/dist/semantic.min.css'
import '@/assets/vendor/fomantic-ui/dist/semantic.min.js'

// Global AJAX setup with custom app headers and global auth checks
$.ajaxSetup({
  headers: {
    'x-api-version': __API_VERSION,
    'x-app-id': __APPLICATION_ID,
  },
  xhrFields: {
    withCredentials: true,
  },
  error: function (jqXHR) {
    const QUERY = window.btoa(
      `?appId=${__APPLICATION_ID}&apiVersion=${__API_VERSION}`,
    )
    const LOGIN_URL = `${AUTH_URL}/account/first?q=${QUERY}`

    switch (jqXHR.status) {
      case 401:
        // Authenticated prior to this - token extension failed - reached max time
        // Redirect to session-expired error page where user can go back to login page
        if (store.state.user.isAuthenticated) {
          clearInterval(window.tokenAutoRenewInterval)
          store.dispatch(`user/${EXIT_SITE}`, '/error/session-expired')
        } else {
          // Not authenticated prior to this - No Token - Redirect to login
          window.location.href = LOGIN_URL
        }
        break
      case 403:
        if (store.state.user.isAuthenticated) {
          window.location.href = '/error/unauthorized'
        } else {
          // Not authenticated prior to this - No Token - Redirect to login
          window.location.href = LOGIN_URL
        }
        break
      // This is exclusively for when API sends explicit 501 when issues like Network or DB error occurs
      // case 500:  <<< this is handled by each page as it could be recoverable - otherwise redirect
      case 501:
        window.location.href = '/error/internal-server-error'
        break
    }
  },
})

$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
  utils.setXSRFRequestHeader(jqXHR)
})

const app = createApp(App)

app.config.globalProperties.$utils = utils
app.config.globalProperties.$_ = _

app.config.errorHandler = function (err, component, info) {
  // eslint-disable-next-line no-console
  console.error(err)
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in.

  if (store.state.user.isAuthenticated) {
    try {
      $.post(`${API_URL}/ui/log`, {
        eventType: 'UIError',
        eventDescription: `Component Element Id: ${
          component.$el
            ? component.$el.id
            : component.$attr
              ? component.$attr.id
              : ' N/A '
        }; Error: ${err}; Info: ${info}`,
        applicationRoute: component.$route.fullPath,
        applicationVersion: __APP_VERSION,
      })
    } catch {
      // no-op
    }
  }
}

app.use(store)
app.use(router)

const IS_PROD = import.meta.env.PROD
// https://matteo-gabriele.gitbook.io/vue-gtag/v/next/
app.use(VueGtag, {
  isEnabled: IS_PROD,
  property: {
    id: 'G-ZJMTZMR56V',
    params: {
      traffic_type: IS_PROD && __ENV === 'PRODUCTION' ? 'prod' : 'internal',
    },
  },
  appName: import.meta.env.VITE_APP_TITLE,
  appId: __APPLICATION_ID,
  appVersion: __APP_VERSION,
})

app.mount('#app')
